import { cx } from "@jugl-web/utils";
import { forwardRef } from "react";
import { PlainButton } from "../../../primitives";
import { ControlBarButton, ControlBarButtonProps } from "../ControlBarButton";
import { ReactComponent as ResetIcon } from "./assets/reset.svg";
import { ReactComponent as FilterIcon } from "./assets/filter.svg";

interface ControlBarFilterButtonProps extends ControlBarButtonProps {
  /**
   * Whether to show a green indicator dot.
   * @default false
   */
  hasActiveFilter?: boolean;
  /**
   * Callback to trigger the reset filters action.
   * If not provided, a reset button will not be shown.
   * @default undefined
   */
  onResetFilters?: () => void;
}

export const ControlBarFilterButton = forwardRef<
  HTMLButtonElement,
  ControlBarFilterButtonProps
>(({ isActive, hasActiveFilter = false, onResetFilters, ...props }, ref) => {
  const shouldShowResetButton = hasActiveFilter && !!onResetFilters;

  return (
    <ControlBarButton
      ref={ref}
      className="max-w-[250px] truncate"
      startSlot={
        <span className="relative flex items-center justify-center gap-2">
          <FilterIcon className="fill-grey" />
          {hasActiveFilter && (
            <div
              className={cx(
                "absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full border-[1.5px] border-solid border-white bg-gradients-success"
              )}
            />
          )}
        </span>
      }
      endSlot={
        shouldShowResetButton ? (
          <PlainButton
            className="rounded-full bg-[#EEF2F5] transition-colors hover:bg-grey-300"
            onClick={(event) => {
              event.stopPropagation();
              onResetFilters();
            }}
          >
            <ResetIcon />
          </PlainButton>
        ) : undefined
      }
      isActive={isActive || hasActiveFilter}
      {...props}
    />
  );
});
